// TODO: Fill all the data
const teamData = [
  {
    id: 1,
    name: "Dr Elisha Caldwell, DHA MPH",
    position: "Founder and CEO",
    description:
      "Elisha is a healthcare expert born in Liberia, Africa. As a refugee, he traveled through Sierra Leone and settled in the United States. He has worked in healthcare in Sierra Leone, South Sudan, Liberia, and the USA for over a decade. Envision, his passion project, was founded in 2018 to improve the livelihoods of vulnerable communities based on his life experiences and education.",
    img: "img/image1.png",
    twiterLink: "",
    instragramLink: "",
    facebookLink: "",
    linkedinLink: "",
  },
  {
    id: 2,
    name: "Steve Mullins, MBA",
    position: "Chief Financial Officer",
    description:
      "Steve Mullins, the Chief Financial Officer for Envision Health Access Initiative, has 37 years’ experience in international business, with postings and experience in Japan and Germany as well as US, the last 25 in positions of general management, including operations, finance and accounting. He holds a MBA in finance and management from California State University. He holds a Black belt certification in six sigma. He has led global companies with responsibility of $100MM+ in Asia, Europe and North America and consulted some 60+ companies in financial restructuring and fiscal management.",
    img: "img/image2.png",
    twiterLink: "",
    instragramLink: "",
    facebookLink: "",
    linkedinLink: "",
  },
  {
    id: 3,
    name: "Harrison Fayia",
    position: "Wash Project Manager",
    description: "",
    img: "img/image4.png",
    twiterLink: "",
    instragramLink: "",
    facebookLink: "",
    linkedinLink: "",
  },
  {
    id: 4,
    name: "Larry M. Tuah",
    position: "M&E Manager",
    description: "",
    img: "img/image5.png",
    twiterLink: "",
    instragramLink: "",
    facebookLink: "",
    linkedinLink: "",
  },
];

export default teamData;
